/**
 * @author 3173
 * @description 直播列表
 * @Date 2020/9/28
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,utils_tool ,component_tool} from '@/tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
let {  WizBrowserExport } = component_tool;

class NormalDealerList extends WizContainer {

  componentName = 'normalDealerList';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleListData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 15
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['name'] = checkStrLength(val['name'], len);
        });
      }
      f(o['data']['records'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '经销商名称',
        field: 'dealerName',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '销售代码',
        field: 'preSalesNumber',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: "售后代码",
        field: "afterSalesNumber",
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: "品牌",
        field: "orgName",
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: "区域",
        field: "regionName",
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: "开店状态",
        field: "stateStr",
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']
      let _data = []
      data && data.forEach(d => {
        let _d = { ...d }
        if(_d['state']===0){
          _d.stateStr = '已关店'
        }else if(_d['state']===1){
          _d.stateStr = '已开店'
        }else if(_d['state']===2){
          _d.stateStr = '建设中'
        }
        _data.push(_d)
      });
   
      WizBrowserExport({
        title: '正常经销商信息',
        sheetName: '正常经销商信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '正常经销商信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
    
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        list: this._handleListData,
        export: this._handleFile,
        delete: this._handleCMD
      },
     
    })
    return <WizReduxTemplate {..._reduxTemplateCofig}  />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(NormalDealerList);
